import { render, staticRenderFns } from "./MultiElement.vue?vue&type=template&id=181535f6&"
import script from "./MultiElement.vue?vue&type=script&lang=js&"
export * from "./MultiElement.vue?vue&type=script&lang=js&"
import style0 from "./MultiElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports